module.exports = __webpack_public_path__ + "media/images/icons/icons_large/14_letter-80efa89dbcff2b033e3048e545f2b18e.png";